import React, {useCallback, useState} from 'react';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {Message} from '@pb/kit-component-message';

import {useRemoveNotification} from './hooks/useRemoveNotification';

type Props = {
    notificationId: string,
    onSuccess: () => void,
    onClose: () => void,
};

export const REMOVE_NOTIFICATION_MODAL_WIDTH = 420;

export const RemoveNotification = ({notificationId, onSuccess, onClose}: Props) => {
    const [serverError, setServerError] = useState<string | undefined>(undefined);
    const {busy, event} = useRemoveNotification({
        notificationId,
        onSuccess,
        onFail: setServerError,
    });

    const onRemove = useCallback(() => {
        event();
    }, [event]);

    return (
        <>
            <DialogHeader onClose={onClose}>
                Remove Notification
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                {serverError ? <Message color="error">{serverError}</Message> : null}
                Are you sure you want to remove this notification?
            </DialogMain>
            <DialogFooter>
                <Group direction="h">
                    <Button busy={busy} variant="Type.PRIMARY" onClick={onRemove}>
                        Remove
                    </Button>
                    <Button variant="Type.SECONDARY" onClick={onClose}>
                        Cancel
                    </Button>
                </Group>
            </DialogFooter>
        </>
    );
};
